/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachines/Utilities" />

export namespace VirtualMachinesProviderType {
    export const GenericProvider = "GenericProvider";
}

export namespace OperationSystem {
    export const Windows = "Windows";
    export const Linux = "Linux";
}

export namespace VirtualMachineConfigurationScripts {
    export const Windows = "If(-NOT (Test-Path $env:SystemDrive\\'azagent')){{mkdir $env:SystemDrive\\'azagent'}}; cd $env:SystemDrive\\'azagent'; for($i=1; $i -lt 100; $i++){{$destFolder=\"A\"+$i.ToString();if(-NOT (Test-Path ($destFolder))){{mkdir $destFolder;cd $destFolder;break;}}}}; $agentZip=\"$PWD\\agent.zip\";$DefaultProxy=[System.Net.WebRequest]::DefaultWebProxy;$securityProtocol=@();$securityProtocol+=[Net.ServicePointManager]::SecurityProtocol;$securityProtocol+=[Net.SecurityProtocolType]::Tls12;[Net.ServicePointManager]::SecurityProtocol=$securityProtocol;$WebClient=New-Object Net.WebClient; $Uri='{0}';if($DefaultProxy -and (-not $DefaultProxy.IsBypassed($Uri))){{$WebClient.Proxy= New-Object Net.WebProxy($DefaultProxy.GetProxy($Uri).OriginalString, $True);}}; $WebClient.DownloadFile($Uri, $agentZip);Add-Type -AssemblyName System.IO.Compression.FileSystem;[System.IO.Compression.ZipFile]::ExtractToDirectory( $agentZip, \"$PWD\");.\\config.cmd {1} --agent $env:COMPUTERNAME --runasservice --work '_work' --url '{2}'{3}{4}{5}; Remove-Item $agentZip;";
    export const LinuxService = "mkdir azagent;cd azagent;curl -fkSL -o vstsagent.tar.gz {0};tar -zxvf vstsagent.tar.gz;./config.sh {1} --acceptteeeula --agent $HOSTNAME --url {2} --work _work{3}{4}{5} --runasservice;sudo ./svc.sh install;sudo ./svc.sh start";
    export const LinuxInteractive = "mkdir azagent;cd azagent;curl -fkSL -o vstsagent.tar.gz {0};tar -zxvf vstsagent.tar.gz;./config.sh {1} --acceptteeeula --agent $HOSTNAME --url {2} --work _work{3}{4}{5};./run.sh";
    export const Linux = "mkdir azagent;cd azagent;curl -fkSL -o vstsagent.tar.gz {0};tar -zxvf vstsagent.tar.gz; if [ -x \"$(command -v systemctl)\" ]; then ./config.sh {1} --acceptteeeula --agent $HOSTNAME --url {2} --work _work{3}{4}{5} --runasservice; sudo ./svc.sh install; sudo ./svc.sh start; else ./config.sh {1} --acceptteeeula --agent $HOSTNAME --url {2} --work _work{3}{4}{5}; ./run.sh; fi";
    export const CollectionName = " --collectionname '{0}'";
    export const PSAdminPromptCheck = "$ErrorActionPreference=\"Stop\";If(-NOT ([Security.Principal.WindowsPrincipal][Security.Principal.WindowsIdentity]::GetCurrent() ).IsInRole( [Security.Principal.WindowsBuiltInRole] \"Administrator\")){{ throw \"{0}\"}};";
    export const PSMinVersionCheck = "If($PSVersionTable.PSVersion -lt (New-Object System.Version(\"3.0\"))){{ throw \"{0}\" }};";
    export const EnvironmentNameParams = "--environment --environmentname \"{0}\"";
    export const ProjectParams = " --projectname '{0}'";
    export const AuthParamIntegrated = " --auth Integrated";
    export const AuthParamNegotiate = " --auth Negotiate";
    export const AuthParameters = " --auth PAT --token {0}";
    export const ScriptFormatPowerShell = "```powershell\r\n{0}\r\n```";
    export const ScriptFormatBash = "```bash\r\n{0}\r\n```";
}

export function copyToClipboard(text: string) {
    const listener = (e: ClipboardEvent) => {
        if (e.clipboardData) {
            e.clipboardData.setData("text/plain", text);
            e.preventDefault();
        }
    };

    // Add a listener to the copy event, and add it to the clipboard. Then remove the handler immediately, as it prevents default
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
}

export namespace ResourceTargetConstants {
    export const Windows = "win-x64";
    export const Linux = "linux-x64";
}

export namespace Operations {
    export const UpdatePackage = "packageUpdate";
}

export class PageKey {
    public static AddEnvironmentView = "add-environment";
    public static AgentPackageGet = "agent-package-get";
    public static AddEnvironmentPAT = "add-environment-pat";
};